module.exports = __webpack_public_path__ + "img/tongjiang.408deed0.png";